export default __webpack_public_path__ + "static/media/etsyLogo.cf07bb9f.png";